export type { TBotFullPageCard } from './model/types';
export { BotFullPageCard } from './ui/BaseLayout';
export { BotPaywallModal } from './ui/BotPaywallModal';
